import { create } from 'zustand';

interface MaterialClipboardState {
  /** Material copied off a panel row, or null when nothing is copied. */
  materialId: string | null;
  /** Display name for the copied material, shown on the clipboard bar. */
  materialName: string | null;
  copy: (material: { id: string; name: string }) => void;
  clear: () => void;
}

/**
 * One material, held in memory for the life of the page.
 *
 * Deliberately NOT persisted to localStorage (unlike moduleStore): the
 * clipboard should survive closing a template editor and opening another, and
 * a page reload should start clean.
 */
export const useMaterialClipboard = create<MaterialClipboardState>((set) => ({
  materialId: null,
  materialName: null,
  copy: ({ id, name }) => set({ materialId: id, materialName: name }),
  clear: () => set({ materialId: null, materialName: null }),
}));
